import { fileExtensionRegex } from "@constants";
import { useContentResourcesStore } from "@stores/ContentResources";
import { useCallback, useState } from "react";
import { FileRejection, useDropzone } from "react-dropzone";

import { ContentDropzoneProps, ContentDropzoneState } from "./ContentDropzone.types";

export const useContentDropzone = ({ onFileUpload, multiple = false }: ContentDropzoneProps) => {
  const setIsRenaming = useContentResourcesStore(state => state.setIsRenaming);

  const [state, setState] = useState<ContentDropzoneState>({
    showRenameFile: false,
    files: null,
  });

  // feature rename file temporary disabled
  const renameFile = (newName?: string) => {
    if (state.files) {
      const fileExtension = state.files[0].name.match(fileExtensionRegex);
      const newFileName = newName?.concat(fileExtension?.toString() || "");
      setState(prevState => ({
        ...prevState,
        showRenameFile: false,
      }));
      setIsRenaming(false);
      onFileUpload(state.files, newFileName);
    }
  };

  const cancelRenameFile = () => {
    setState(() => ({
      files: null,
      showRenameFile: false,
    }));
    setIsRenaming(false);
  };

  // feature rename file temporary disabled
  const onDrop = useCallback(
    async (acceptedFiles: File[], rejectedFiles: FileRejection[]) => {
      // setIsRenaming(true);
      setState(prevState => ({
        ...prevState,
        // showRenameFile: true,
        files: acceptedFiles.length > 0 ? acceptedFiles : null,
      }));
      onFileUpload(acceptedFiles);
    },
    [onFileUpload]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple,
  });

  return {
    state,
    getRootProps,
    getInputProps,
    isDragActive,
    renameFile,
    cancelRenameFile,
  };
};
